import React from 'react';
import { resolveImageUrl, DEFAULT_LOGO, DEFAULT_CARD_BG } from '../../utils/imageDefaults';
import { buildCardBackground, getSurfaceClassName } from '../../utils/cardSurface';
import { resolveTemplateColor } from '../../utils/templateColors';

const RegisterCardPreview = ({ user }) => {
  const mainColor = resolveTemplateColor(user?.mainColor, 'mainColor');
  const textColor = resolveTemplateColor(user?.textColor, 'textColor');
  const labelColor = resolveTemplateColor(user?.labelColor, 'labelColor');
  const imageUrl = resolveImageUrl(user?.backgroundUrl, DEFAULT_CARD_BG);
  const logoUrl = resolveImageUrl(user?.logoUrl, DEFAULT_LOGO);
  const bgImage = buildCardBackground({ imageUrl, cardStyle: 'plastic' }, true);

  return (
    <div className="admin-register-preview-wrap">
      <p className="admin-preview-caption">Превью карточки при регистрации</p>
      <div
        className={`admin-register-preview ${getSurfaceClassName('plastic')}`}
        style={{
          backgroundColor: mainColor,
          color: textColor,
          backgroundImage: bgImage,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <img
          src={logoUrl}
          alt=""
          className="admin-register-preview-logo"
          onError={(e) => { e.target.src = DEFAULT_LOGO; }}
        />
        <span className="admin-register-preview-name" style={{ color: textColor }}>
          {user?.accountName || 'Магазин'}
        </span>
        <span className="admin-register-preview-hint" style={{ color: labelColor }}>
          Нажмите для регистрации
        </span>
      </div>
    </div>
  );
};

export default RegisterCardPreview;
